
import React, { useEffect, useMemo, useState } from 'react'
import HeaderComponent from '../components/HeaderComponent'
import { LoadingPage } from '../components/PageLoading'
import { fetchWithTokenRefresh, useAuth } from '../providers/AuthContext'
import { getFetcherWithResponse, postFetcherWithResponse } from '@startlibs/utils'
import { getJwt, setJwt } from '../hooks/useJwt'
import { getRefreshToken, setRefreshToken } from '../hooks/useRefresh'
import { setNotification } from '../components/Notifications'
import { navigate } from '@reach/router'
import { MENU_ITEMS } from '../utils/constants'

export const UserManagementPage = ({ instanceData }) => {

  const { menu } = useAuth();
  const baseURL = useMemo(() => process.env.NODE_ENV == 'development' ? "https://purviewimage-us-east-2.purview.net/" : window?.user_management_url || "https://purviewimage-us-east-2.purview.net/", []);
  
  const title = instanceData?.title || 'Purview Image - User Management'
  const { isCheckingAuth, authUser, setIsCheckingAuth, setMenu, setAuthUser, setPacsDbName } = useAuth()
  const [isLoading, setIsLoading] = useState(false)
  const [jwtUserManegement, setJwtUserManegement] = useState()
  const [username, setUsername] = useState()
  const [url, setUrl] = useState()
  const [canAccess, setCanAccess] = useState(false)

  useEffect(() => {
    document.title = title
  }, [title])

  useEffect(() => {

    const jwt = getJwt()
    if (jwt) {
      postFetcherWithResponse('/gw/refresh', {}, {
        headers: {
          'Authorization': 'Bearer ' + getRefreshToken(),
          'X-Auth-Token': jwt,
        }
      }).then(([data, res]) => {
        const authToken = res.headers.get('X-Auth-Token');
        setJwt(authToken, 'worklist');
        const refreshToken = res.headers.get('X-Refresh-Token');
        setRefreshToken(refreshToken, 'refreshToken');
        fetchWithTokenRefresh(
          getFetcherWithResponse,
          '/gw/worklist/options-and-rights',
          {},
          {},
          { jwt: authToken, setJwt: (jwt) => setJwt(jwt, 'worklist'), setRefreshToken: (refreshToken) => setRefreshToken(refreshToken, 'refreshToken') },
          'login',
          false
        ).then(([data, res]) => {
          // Filter the menus based on the presence of the name in data.auth array
          const availableMenuItens = MENU_ITEMS.filter(item => data.menus.includes(item.name));
          setMenu(availableMenuItens)
          setAuthUser(data?.username)
          setPacsDbName(data?.pacsdbname)
          setIsCheckingAuth(false)
          return fetchWithTokenRefresh(getFetcherWithResponse, '/gw/worklist/user-management-token', {}, {}, { jwt: getJwt(), setJwt, setRefreshToken }, 'login', true)
            .then(([data, res]) => {
              setJwtUserManegement(data?.jwt)
              setUsername(data?.username)
              // let localUrl = window.user_management_url || 'https://purviewimage-us-east-2.purview.net/'
              // localUrl = localUrl + '?jwt=' + data?.jwt + '&username=' + data?.username + '&from=gw2'
              let localUrl = baseURL + '?jwt=' + data?.jwt + '&username=' + data?.username + '&from=gw2'
              setUrl(localUrl)
              setIsLoading(false)
            })
            // .catch(err => {
            //   console.log(err)
            //   setIsLoading(false)
            //   setNotification({ type: 'alert', msg: 'Your session has expired. Please login again.' })
            // })
        })
          .catch(err => {
            console.log('errrrrrr', err)
            console.log(err)

            if (err && err.length > 1) {
              const status = err[1]?.status || 0
              if (status === 403) {
                setNotification({ type: 'alert', msg: 'Your session has expired. Please login again.' })
                return
              }
              navigate('/login')
            }
          })
          .finally(() => {
            setIsCheckingAuth(false)
          })
      }).catch(([res, refreshErr]) => {
        // console.log(res, refreshErr)
        const refreshStatus = refreshErr?.status || 0;
        if (refreshStatus === 401) {
          localStorage.removeItem('worklist-jwt')
          localStorage.removeItem('refreshToken')
          navigate('login#session-expired')
        }
        throw refreshErr;
      })
    }

  }, [])

  useEffect(() => {
      if(menu) {
        if(menu.length > 0) {
          const pageIsEnabled = menu.find(item => item.path === '/user-management')
          if(!pageIsEnabled) {
            setNotification({ type: 'alert', msg: 'You do not have access to this page.' })
            setTimeout(() => {
              navigate('/')            
            }, 2000)
          }else{
            setCanAccess(true)
          }
        }
      }
    }, [menu])
  

  if (isCheckingAuth || isLoading || !url || !canAccess) {
    return <><LoadingPage /></>
  }


  return <div style={{ height: '100vh' }}>
    <HeaderComponent />
    <iframe
      src={url}
      sandbox="allow-scripts allow-same-origin allow-popups allow-top-navigation allow-top-navigation-by-user-activation allow-forms"
      width={'100%'}
      title={title}
      style={{ border: '0px', margin: '0px', padding: '0px', minHeight: 'calc(100% - 66px)' }}>
    </iframe>
  </div>
}